'use client';

import { useQuery } from '@tanstack/react-query';

import { getArticlesQueryParams } from '@/features/articles/queries';
import { Article } from '@/components/Article';
import { Topic } from '@/components/Topic';
import { type Article as ArticleType } from '@/shared/types';
import { Box, Text } from '@/shared/ui';
import styles from './ArticleView.module.css';

interface ArticleViewProps {
  article: ArticleType | null;
  category: string;
}

export function ArticleView({ article, category }: ArticleViewProps) {
  const possibleRubrics = article?.rubric_ids?.map((item) => item.slug) ?? [];
  const redirectUrl = possibleRubrics.length
    ? `/rubric/${possibleRubrics[0]}`
    : undefined;

  const { data: articles } = useQuery(
    getArticlesQueryParams({
      limit: 6,
    })
  );
  const visibleArticles = articles?.filter((item) => item.id !== article?.id);

  if (!article) {
    return (
      <Box className={styles.root}>
        <Text fontSize={18} color="black" fontWeight={600}>
          {'Нет результатов'}
        </Text>
      </Box>
    );
  }

  return (
    <Box display="flex" flexDirection="column" gap={16} paddingBottom={12}>
      <Article categorySlug={category} {...article} />
      <Topic
        title="Читайте также"
        articles={visibleArticles ?? []}
        redirectUrl={redirectUrl}
      />
    </Box>
  );
}
